export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11889.81946df9.jpg";